export default class NavbarUtils {
    public toggleMenuCollapse(): void {
        jq(document.documentElement).on("click",
            ".menu-collapse-selector",
            () => {
                const cardEl = jq("#navbarSupportedContent");
                cardEl.collapse("toggle");
            });
    }

    public toggleMenuItemExpansion(): void {
        jq(document.documentElement).on("mouseenter mouseleave",
            ".navbar .dropdown",
            (event) => {
                const dropdownEl = jq(event.target as Node as HTMLElement).closest(".dropdown");
                const dropdownMenuEl = dropdownEl.find(".dropdown-menu");
                const isDropdownActive = dropdownEl.is(":hover");
                const toggleClassAction = isDropdownActive ? "addClass" : "removeClass";
                dropdownMenuEl[toggleClassAction]("show"); // TODO Use dropdown method
                dropdownEl.find("button.dropdown-toggle")[toggleClassAction]("active");
                jq(`[data-bs-toggle="dropdown"]`, dropdownEl).attr("aria-expanded", String(isDropdownActive));
            });
    }

    public attachHideTestingAlert(): void {
        jq("#testing-environment-alert").on("click", (event) => {
            jq(event.currentTarget).closest(".testing-environment-alert").remove();
            this.calculateHeightFunction();
        });
    }

    public trackWindowResize(): void {
        window.addEventListener("resize", this.calculateHeightFunction);
        this.calculateHeightFunction();
    }

    private calculateHeightFunction(): void {
        const doc = document.documentElement;
        const testingEnvironmentAlert = jq(".testing-environment-alert");
        let windowAvailableHeight: string;
        if (testingEnvironmentAlert.length > 0) {
            windowAvailableHeight = `${window.innerHeight - testingEnvironmentAlert.outerHeight(true)}px`;
        } else {
            windowAvailableHeight = `${window.innerHeight}px`;
        }
        doc.style.setProperty("--app-height", windowAvailableHeight);
    }
}
